import { $host } from './index';
import { ENDPOINTS } from '../constants/endpoints';

export const getMontonioPaymentMethods = async (country = 'LV') => {
  try {
    const { data } = await $host.get(ENDPOINTS.MONTONIO.PAYMENT_METHODS, {
      params: { country }
    });
    return data;
  } catch (error) {
    console.log(error);
    throw error?.response?.data;
  }
}; 